import React, {PureComponent} from 'react';
import {Link} from "react-router-dom";
import { Redirect } from "react-router";

import {withTranslation} from 'react-i18next';
import Input from "../../UI/Input/Input";
import {toast} from "react-toastify";
import PageTitle from "../../Commons/PageTitle";
import axios from "../../../axios-defaults";
import Spinner from "../../UI/Spinner";
import ModalMxo from "../../UI/Modal";
import AccountNumberHelperModal from "../../UI/Helper/AccountNumberHelperModal";

class AddLinkedAccount extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            success: false,
            loading: false,
            validationLoading: false,
            formIsValid: false,
            redirectToListing: false,
            showModalHelper:false,
            form: {
                subtitle: 'linkedaccounts.form.add.title',
                elements: {
                    account_code: {
                        elementType: 'input',
                        elementConfigs: {
                            type: 'text',
                            name: 'account_code',
                            autoComplete: 'account_code',
                            id: 'account_code',
                        },
                        label: "linkedaccounts.form.add.account_code",
                        placeholder: 'linkedaccounts.table.header.account_code',
                        value: '',
                        validationRules: {
                            required: true
                        },
                        valid: false,
                        touched: false,
                        errorMessage: "errors.fieldrequired"
                    },
                },
                questions: {}
            }
        }
    }

	getAccountQuestions = (account_code) => {
		this.setState({loading: true});

		axios.post('/accounts/' + account_code + '/isblocked')
			.then((blockResponse) => {
				if (blockResponse.data.isBlocked) {
					// If the account is blocked, show an error message and stop the process
					const updatedForm = {...this.state.form};
					const updatedFormElement = {...updatedForm.elements['account_code']}

					updatedFormElement.valid = false;
					updatedFormElement.touched = true;
					updatedFormElement.errorMessage = this.props.t("linkedaccounts.account_blocked");
					updatedForm.elements['account_code'] = updatedFormElement;

					this.setState({
						form: updatedForm,
						formIsValid: false,
						loading: false
					});

					return; // Exit early if account is blocked
				} else {
					// If not blocked, proceed to get account questions
					axios.get('/accounts/authentificationQuestions?accountCode=' + account_code)
						.then((response) => {
							if (response.data.succeeded) {
								let labelAccessor = 'descriptionEn';
								if (this.props.i18n.language === 'fr') labelAccessor = 'descriptionFr';

								let questionsArray = [];
								if (Array.isArray(response.data.data) && response.data.data.length > 0) {
									this.setState({
										formIsValid: false
									});

									response.data.data.map((item) => {
										questionsArray[item.code] ={
											elementType: 'input',
											elementConfigs: {
												type: 'text',
												placeholder: 'Answer',
												name: item.code,
												autoComplete: '',
												id: item.code,
											},
											label: item[labelAccessor],
											value: '',
											validationRules: {
												required: true
											},
											valid: false,
											touched: false,
											errorMessage: "errors.fieldrequired",
										};
									});
								}

								const updatedForm = {...this.state.form};
								updatedForm.questions = questionsArray;

								this.setState({
									form: updatedForm,
									loading: false
								});
							} else {
								this.setState({loading: false});
							}
						})
						.catch((error) => {
							const updatedForm = {...this.state.form};
							const updatedFormElement = {...updatedForm.elements['account_code']}

							updatedFormElement.valid = false;
							updatedFormElement.touched = true;
							updatedFormElement.errorMessage = this.props.t("linkedaccounts.invalidnumber");
							updatedForm.elements['account_code'] = updatedFormElement;

							this.setState({
								form: updatedForm,
								formIsValid: false,
								loading: false
							});
						});
				}
			})
			.catch((error) => {
				// Handle error
				this.setState({loading: false});
			});
	}

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {...this.state.form};
        const updatedFormElement = {...updatedForm.elements[inputIdentifier]}

        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = this.checkValidity(updatedFormElement.value, {required: true});
        updatedFormElement.touched = true;
        updatedFormElement.errorMessage = "errors.fieldrequired";

        updatedForm.elements[inputIdentifier] = updatedFormElement;

        if (inputIdentifier === 'account_code')
            (event.target.value.trim().length === 8)?
                this.getAccountQuestions(event.target.value.trim()):
                updatedForm.questions = {};

        this.setState({
            form: updatedForm,
            formIsValid: false
        });
    }

    inputAnswerChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {...this.state.form};
        const updatedFormElement = {...updatedForm.questions[inputIdentifier]}

        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = this.checkValidity(updatedFormElement.value, {required: true});
        updatedFormElement.touched = true;
        updatedForm.questions[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm.questions) {
            formIsValid = updatedForm.questions[inputIdentifier].valid && formIsValid;
        }

        this.setState({
            form: updatedForm,
            formIsValid: formIsValid
        });
    }

    checkValidity = (value, rules) => {
        let isValid = true;

        if (rules.required) {
            isValid = value.trim() !== '' && isValid;
        }

        return isValid;
    }

    authentifyInfos = (e) => {
        e.preventDefault();

        if (!this.state.formIsValid) {
            toast.error(
                <div>
                    <i className="fal fa-exclamation-circle"></i>&nbsp; The form is invalid and can't be submitted
                </div>
            );
        }

        this.setState({
            validationLoading: true
        });

        const {form} = this.state;

        let elements = form.elements;
        let questions = form.questions;

        var dataArray = {
            accountCode: elements.account_code.value.trim(),
            authentificationAnswerList: []
        };

        for (let question in questions) {
            dataArray.authentificationAnswerList.push({
                questionCode: question,
                answer: questions[question].value.trim()
            })
        }

        axios.post('/auth/link-account/validate-answers', JSON.stringify(dataArray))
            .then((response) => {
                if (!response.data.succeeded){

                    let message = response.data.accountAlreadyOwned?"linkedaccounts.owner_existing":"linkedaccounts.invalidanswers";

                    const updatedForm = {...this.state.form};
                    const updatedFormElement = {...updatedForm.elements['account_code']}

                    updatedFormElement.valid = false;
                    updatedFormElement.touched = true;
                    updatedFormElement.errorMessage = message;
                    updatedForm.elements['account_code'] = updatedFormElement;

                    this.setState({
                        form: updatedForm,
                        formIsValid: false
                    });

                    toast.error(
                        <div>
                            <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t(message)}
                        </div>
                    );
                }
                else{
                    let valid = response.data.succeeded
                    for (let question_code in response.data.data) {
                        valid = response.data.data[question_code].validAnswer && valid
                    }

                    if (valid){
                        toast.success(
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t("linkedaccounts.add_success")}
                            </div>
                        );

                        axios.post('/auth/link-account', {account_number:elements.account_code.value})
                            .then((response) => {
                                this.setState({ redirectToListing: true });
                            }, (error) => {
                                toast.error(
                                    <div>
                                        <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t("linkedaccounts.invalidanswers")}
                                    </div>
                                );
                            });
                    }else{
                        toast.error(
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t("linkedaccounts.invalidanswers")}
                            </div>
                        );
                    }
                }
            }, (error) => {
                toast.error(
                    <div>
                        <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t("errors.error")}
                    </div>
                );
            })
            .finally(() => {
                this.setState({
                    validationLoading: false
                });
            });
    }

    openModalHelper = () =>{
        this.setState({
            showModalHelper: true
        });
    }
    closeModalHelper = () =>{
        this.setState({
            showModalHelper: false
        });
    }

    render() {
        const {loading, formIsValid, redirectToListing, validationLoading} = this.state;
        const {elements, questions} = this.state.form;

        const questionsElements = [];
        for (let key in questions) {
            questionsElements.push({
                id: key,
                configs: questions[key]
            })
        }

        if (redirectToListing) {
            return <Redirect to = {{ pathname: "/accounts/change-account" }} />;
        }

        return (
            <div className="container container--larger linked-account-add-form">
                <div className="row flex flex--wrap">
                    <div className="col-md-6">
                        <PageTitle title={this.props.t("linkedaccounts.form.header")}/>
                    </div>
                </div>
                <div className="row flex flex--wrap">
                <div className="col-sm-6 col-md-6 ">
                    <h3 className={"headline--block headline"}>{this.props.t(this.state.form.subtitle)}</h3>
                    <p>{this.props.t("linkedaccounts.form.add.instructions")}</p>
                        {(validationLoading ? <Spinner/> : (
                            <div>

                                <Input key={elements.account_code.elementConfigs.id}
                                       label={elements.account_code.label}
                                       helper={<>
                                           <button className="link link--red link--underline link--hover--red" onClick={this.openModalHelper}>
                                               {this.props.t("linkedaccounts.wherefind")}?
                                           </button>

                                           <ModalMxo title={this.props.t("linkedaccounts.wherefind")}
                                                     show={this.state.showModalHelper}
                                                     hideFooter={true}
                                                     footerActions={<div
                                                         className="modal-footer justify-content-center">
                                                         <button onClick={this.closeModalHelper}
                                                                 className="btn btn--raised btn--raised--red btn--fs-12"
                                                                 style={{minWidth : "160px"}}>{this.props.t('linkedaccounts.modalhelper.close')}</button>
                                                     </div>}
                                                     backDrop={true}
                                                     onHide={this.closeModalHelper}
                                                     onShow={this.openModalHelper}
                                                    >
                                               <AccountNumberHelperModal />
                                           </ModalMxo>
                                       </>}
                                       elementtype={elements.account_code.elementConfigs.elementType}
                                       elementconfigs={elements.account_code.elementConfigs}
                                       value={elements.account_code.value}
                                       valid={elements.account_code.valid}
                                       shouldValidate={elements.account_code.validationRules}
                                       touched={elements.account_code.touched}
                                       placeholder={elements.account_code.placeholder}
                                       changed={(event) => this.inputChangedHandler(event, elements.account_code.elementConfigs.id)}
                                       errorMessage={elements.account_code.errorMessage}/>

                                {(loading) ? <Spinner/> :
                                    questionsElements.length ?
                                        questionsElements.map(element => (
                                            <Input key={element.id}
                                                   label={element.configs.label}
                                                   elementtype={element.configs.elementType}
                                                   elementconfigs={element.configs.elementConfigs}
                                                   value={element.configs.value}
                                                   valid={element.configs.valid}
                                                   shouldValidate={element.configs.validationRules}
                                                   touched={element.configs.touched}
                                                   changed={(event) => this.inputAnswerChangedHandler(event, element.configs.elementConfigs.id)}
                                                   errorMessage={element.configs.errorMessage}/>
                                        )) : ''}
                                </div>
                            )
                        )}

                    <div className="form__action">
                        <Link className="btn btn-primary btn-sm" to="/accounts/change-account">
                            {this.props.t("linkedaccounts.form.add.cancelbtn")}&nbsp;&nbsp;<i
                            className="fas fa-angle-right"></i>
                        </Link>
                        <button type="submit" className="btn btn--raised--red btn--raised"
                                disabled={!formIsValid}
                                onClick={this.authentifyInfos}>
                            {this.props.t("linkedaccounts.form.add.submitbtn")}&nbsp;&nbsp;<i
                            className="fas fa-angle-right"></i>
                        </button>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(AddLinkedAccount);
